import { useContext, Fragment } from 'react';

import ModalSignup from 'components/modal/signups';

import { ScheduleDemoWizardContext } from '../schedule-demo-wizard';
import { PromoText } from '../types/config';
import { ScheduleDemoMercuryAction } from '../util/send-mercury-event';

type Props = {
  textConfig: PromoText;
};

const StepStartTrialPromo = (props:Props) => {
  const { emitEvent } = useContext(ScheduleDemoWizardContext);

  const handleSuccessfulSignup = (data: any) => {
    emitEvent({
      action: ScheduleDemoMercuryAction.START_TRIAL_SUCCESSFUL,
      formData: {
        formId: 'scheduleDemoTrialSignUp',
        insensitiveFields: {
          company: data.account.company,
          employeeCount: data.account.employee_count,
        },
        sensitiveFields: {
          email: data.user.email,
          firstName: data.user.first_name,
          lastName: data.user.last_name,
          phoneNumber: data.user.phone_number,
        },
      },
    });
  };

  const handleModalOpen = () => {
    emitEvent({
      action: ScheduleDemoMercuryAction.START_TRIAL_MODAL_OPENED,
    });
  };

  return (
    <Fragment>
      <h1 className="schedule-demo-wizard--title">{props.textConfig.title}</h1>
      <p className="schedule-demo-wizard--copy">{props.textConfig.copy}</p>
      <ModalSignup
        showModalButton
        signupModalLaunch={ props.textConfig.button }
        buttonClasses="button is-rounded green-pill-button schedule-demo-start-free-trial-button"
        onSuccessfulSignup={ handleSuccessfulSignup }
        modalOpenCallback={ handleModalOpen }
      />
    </Fragment>
  );
};

export default StepStartTrialPromo;
